import { useState } from "react";
import { format } from "date-fns";
import { CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Calendar + time picker; value/onChange use "YYYY-MM-DDTHH:mm" (same as datetime-local).
export function DateTimePicker({ value, onChange, testId = "datetime-picker", placeholder = "Pick date & time" }) {
  const [open, setOpen] = useState(false);
  const [d, t] = (value || "").split("T");
  const date = d ? new Date(`${d}T00:00`) : undefined;
  const time = (t || "").slice(0, 5) || "09:00";
  const emit = (day, tm) => onChange(day ? `${format(day, "yyyy-MM-dd")}T${tm}` : "");
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className="h-9 w-full justify-start font-normal" data-testid={testId}>
          <CalendarDays className="h-4 w-4 mr-2 opacity-60 shrink-0" />
          <span className={`truncate ${date ? "" : "text-muted-foreground"}`}>{date ? `${format(date, "d MMM yyyy")} · ${time}` : placeholder}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={date} onSelect={(day) => emit(day, time)} disabled={{ before: new Date(new Date().setHours(0, 0, 0, 0)) }} initialFocus data-testid={`${testId}-calendar`} />
        <div className="flex items-center gap-2 border-t border-border p-3">
          <span className="text-xs text-muted-foreground">Time</span>
          <Input type="time" value={time} onChange={(e) => emit(date || new Date(), e.target.value || "09:00")} className="h-8" data-testid={`${testId}-time`} />
          <Button size="sm" className="h-8" onClick={() => setOpen(false)} data-testid={`${testId}-done`}>Done</Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
